// extracted by mini-css-extract-plugin
export default {"box_container":"estilos_box_container__zWC0H","fab_add":"estilos_fab_add__NiMJh"};